// extracted by mini-css-extract-plugin
export default {"buttons":"buttons_buttons__VzLFG"};